import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

const base = "VET_HORSE_DETAILS_PAGE";
export const SET_MAP_POPUP_STATE = `${base}_SET_MAP_POPUP_STATE`;
export const SET_IS_ADD_CUSTOM_RISK_POPUP_OPEN = `${base}_SET_IS_ADD_CUSTOM_RISK_POPUP_OPEN`;
export const SET_RISK_CANDIDATE_FOR_DELETION = `${base}_SET_RISK_CANDIDATE_FOR_DELETION`;

export interface IVetHorseDetailsPageActions {
  type: string;
  mapPopupState: boolean;
  isAddCustomRiskPopupOpen: boolean;
  riskCandidateForDeletion: racehorse360.IHorseRisk;
}

export const setMapPopupState = (
  mapPopupState: boolean
): Partial<IVetHorseDetailsPageActions> => {
  return {
    type: SET_MAP_POPUP_STATE,
    mapPopupState
  };
};

export const setIsAddCustomRiskPopupOpen = (
  isAddCustomRiskPopupOpen: boolean
): Partial<IVetHorseDetailsPageActions> => {
  return {
    type: SET_IS_ADD_CUSTOM_RISK_POPUP_OPEN,
    isAddCustomRiskPopupOpen
  };
};

export const setRiskCandidateForDeletion = (
  riskCandidateForDeletion: racehorse360.IHorseRisk
): Partial<IVetHorseDetailsPageActions> => {
  return {
    type: SET_RISK_CANDIDATE_FOR_DELETION,
    riskCandidateForDeletion
  };
};
